import api from "@/lib/api";

const FILENAMES = { customers: "clients.csv", bookings: "reservations.csv", payments: "paiements.csv", expenses: "depenses.csv" };

export async function downloadCsv(kind, orgId) {
  const res = await api.get("/api/exports", {
    params: { kind, organization_id: orgId },
    responseType: "blob",
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAMES[kind] || `${kind}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
